let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data));
      } catch (error) {
        // Isolate subscriber failures so one bad listener (e.g. cart-items,
        // quick-order-list) can't prevent other subscribers (e.g.
        // cart-notification-popup) from receiving this event.
        console.error(`[pubsub] subscriber for "${eventName}" threw:`, error);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
